<template>
  <div class="segment-expand-btn" v-show="getIsPrint">
    <img ref="arrow" :src="require('@/assets/svg/SVG/segment_arrow.svg')" class="expand-arrow"/>
  </div>
</template>

<script>
import { gsap } from 'gsap';
import { usePrintStore } from '../../store/PrintStore';

export default {
  name: 'SegmentExpand',
  data () {
    return {
      expanded: true
    };
  },
  computed: {
    getIsPrint () {
      return !usePrintStore().getPrintIsOpen;
    }
  },
  mounted () {
    gsap.set(this.$refs.arrow, {
      rotation: 180
    });
  },
  methods: {
    toggle () {
      gsap.to(this.$refs.arrow, {
        rotation: (this.expanded) ? 180 : 0,
        duration: .2
      });
      this.expanded = !this.expanded;
    },
    expand () {
      gsap.to(this.$refs.arrow, {
        rotation: 180,
        duration: .2
      });
      this.expanded = true;
    },
    close () {
      gsap.to(this.$refs.arrow, {
        rotation: 0,
        duration: .2
      });
      this.expanded = false;
    }
  }
};
</script>

<style scoped>
.segment-expand-btn {
  color: black;
  display: flex;
  justify-content: center;
  align-content: flex-end;
  margin-top: auto;
  padding-bottom: 12px;
  cursor:pointer;
  padding-right: 10px;
}
.expand-arrow {
  height: 13px;
}
</style>